import type React from 'react';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '#/ui/utils/types';

export interface DialogActionsProps extends CommonProps {
  children?: React.ReactNode;
  disableSpacing?: boolean;
}

function DialogActions({ children, className, disableSpacing = true }: DialogActionsProps) {
  return (
    <div className={twMerge('gooey-dialog-actions', !disableSpacing && 'gap-2', className)}>
      <div className='d-modal-action'>{children}</div>
    </div>
  );
}
DialogActions.displayName = 'GooeyDialogActions';

export default DialogActions;
